import { Drawer } from "@renderbus/ui";
import styled from "styled-components";

export const ChangeLogDrawer = styled(Drawer)`
  .log-drawer {
    .ant-drawer-header,
    .ant-drawer-body {
      background-color: #262729 !important;
    }
  }
  .transfer-operate .ant-table-cell {
    font-size: 12px;
    height: 36px;
  }
`;
